import { getRequest } from "../../../api/api";

export function getPerformanceRecords(callbackResponse) {
    return getRequest(
        'api/v1/performance/performance-records?months=6',
        null,
        callbackResponse
    )
}